<template>
  <view-time-sheet />
</template>

<script>
import ViewTimeSheet from "@/components/Timesheet/ViewTimeSheet";
export default {
  name: "TimeSheetView",
  components: {
    "view-time-sheet": ViewTimeSheet,
  },
};
</script>

<style scoped></style>
